import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { CmsmoduleService } from 'src/app/manage/cmsmodule/service/cmsmodule.service';
import { BannerService } from 'src/app/services/banner.service';
import { RoleService } from 'src/app/services/role.service';
interface Season {
  name: string;
  code: string;
}
@Component({
  selector: 'app-scoretable',
  templateUrl: './scoretable.component.html',
  styleUrls: ['./scoretable.component.scss']
})
export class ScoretableComponent implements OnInit {
  availableClasses: string[] = ["bg-white", "light", "colorful"];
  currentClassIdx: number = 0;
  bodyClass: string;
  Seasons: Season[];
  //selectedCity: Season;
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  items: MenuItem[];
  public selectedSeasonPoint;
  public seasonpoint = [
    { 'name': "Season 2", "title": "2", "imgsrc": "table2.png", "tplPlayerscoreImg": "" },
    { 'name': "Season 3", "title": "3", "imgsrc": "table3.png", "tplPlayerscoreImg": "wplayer-standings-season-3.png" },
    { 'name': "Season 4", "title": "4", "imgsrc": "table4.png", "tplPlayerscoreImg": "wplayer-standings-season-4.png" },
    { 'name': "Season 5", "title": "5", "imgsrc": "table5.png", "tplPlayerscoreImg": "wplayer-standings-season-5.png" },
    { 'name': "Season 6", "title": "6", "imgsrc": "table6.png", "tplPlayerscoreImg": "wplayer-standings-season-6.png" },
  ];
  public bannerImageList: any[] = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  public selectedTplscoreImg = "table6.png";
  public selectedTplSeason = 6;
  public selectedTplPlayerscoreImg = "";
  constructor(private cmsmoduleService: CmsmoduleService, private bannerService: BannerService,private roleService: RoleService,private router: Router) { 
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }

  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.selectedSeasonPoint = this.seasonpoint.find(seasons => seasons.name === 'Season 6');
    this.selectedTplPlayerscoreImg = this.selectedSeasonPoint.tplPlayerscoreImg;
    this.getCmsContent();
    this.getBanner();
  }

  onSeasonpoint(event) {
    this.selectedTplscoreImg = event.value.imgsrc;
    this.selectedTplSeason = event.value.title;
    this.selectedTplPlayerscoreImg = event.value.tplPlayerscoreImg;
  }
  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=whatistpl";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.cmsContent['cmsDescription'];
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=whatistpl";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }


}
